import React from "react";
import { motion } from "framer-motion";

export const FloatingBlobs = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden">
    <motion.div
      animate={{ x: [0, 40, -10, 0], y: [0, -30, 20, 0], scale: [1, 1.1, 0.95, 1] }}
      transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      className="absolute top-[-12%] left-[-6%] w-[480px] h-[480px] rounded-full blob"
      style={{ background: "radial-gradient(circle, #7C3AED 0%, transparent 70%)", opacity: 0.35 }}
    />
    <motion.div
      animate={{ x: [0, -30, 30, 0], y: [0, 40, -20, 0], scale: [1, 0.9, 1.1, 1] }}
      transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      className="absolute top-[10%] right-[-8%] w-[520px] h-[520px] rounded-full blob"
      style={{ background: "radial-gradient(circle, #EC4899 0%, transparent 70%)", opacity: 0.32 }}
    />
    <motion.div
      animate={{ x: [0, 20, -20, 0], y: [0, 30, -30, 0], scale: [1, 1.05, 0.95, 1] }}
      transition={{ duration: 24, repeat: Infinity, ease: "easeInOut" }}
      className="absolute bottom-[-15%] left-[20%] w-[600px] h-[600px] rounded-full blob"
      style={{ background: "radial-gradient(circle, #A855F7 0%, transparent 70%)", opacity: 0.25 }}
    />
  </div>
);

export const SectionEyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full glass border border-[#7C3AED]/15 text-xs font-bold tracking-[0.18em] uppercase text-[#7C3AED] shadow-xs mb-4">
    <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#EC4899]" />
    {children}
  </span>
);

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

